(function () {
  if (document.querySelectorAll('[data-svg-hover]').length === 0) {
    return;
  }

  window.areaIsometricShow = function (elm) {
    toggleSvgContainer(elm, 1);
  }

  window.areaIsometricHide = function (elm) {
    toggleSvgContainer(elm, 0);
  }

  function toggleSvgContainer(elm, opacity = 0) {
    const svgContainer = document.querySelector(`[data-svg-hover="${elm.getAttribute('data-svg')}"]`)
    if (svgContainer) {
      svgContainer.style.opacity = opacity;
    }
  }
})();
